import React from 'react';

const Cell = ({ cls, data, side, onPick }) => {
  const active = data && data.p;
  return (
    <button
      type="button"
      className={cls}
      onClick={active && onPick ? () => onPick(side, data.p) : undefined}
    >
      <span>{data ? data.p : '-'}</span>
      <small>{data ? data.v : ''}</small>
    </button>
  );
};

export default function OddsRow({ row, marketName, onSelectBet }) {
  const sus = !!row.suspended;
  const b = row.back || [null, null, null];
  const l = row.lay || [null, null, null];
  const pick = (side, odds) => onSelectBet && onSelectBet({ side, team: row.team, odds, marketName });
  return (
    <div className="row mx-0 align-items-center">
      <div className="col-lg-6 col-md-5 col-8 px-0">
        <span className="marketevent">{row.team}</span>
      </div>
      <div className="col-lg-6 col-md-7 col-4 px-0">
        <div className="btn-group">
          <Cell cls="back back-light d-md-block d-none" data={sus ? null : b[0]} side="back" onPick={pick} />
          <Cell cls="back back-light d-md-block d-none" data={sus ? null : b[1]} side="back" onPick={pick} />
          <Cell cls="back" data={sus ? null : b[2]} side="back" onPick={pick} />
          <Cell cls="lay" data={sus ? null : l[0]} side="lay" onPick={pick} />
          <Cell cls="d-md-block d-none lay lay-light" data={sus ? null : l[1]} side="lay" onPick={pick} />
          <Cell cls="d-md-block d-none lay lay-light" data={sus ? null : l[2]} side="lay" onPick={pick} />
        </div>
        {sus && <div className="suspended">{row.suspendedText || 'SUSPENDED'}</div>}
      </div>
    </div>
  );
}
